<div class="breadcrumb-container">
  <nz-breadcrumb [nzSeparator]="separatorTemplate" *ngIf="this.breadcrumbs.length > 1">
    <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs; let last = last">
      <a *ngIf="!last" [routerLink]="breadcrumb.url" class="bc bc-link">{{ breadcrumb.label }}</a>
      <span *ngIf="last" class="bc bc-current">{{ breadcrumb.label }}</span>
    </nz-breadcrumb-item>
    <ng-template #separatorTemplate>
      <span class="bc-sep">›</span>
    </ng-template>
  </nz-breadcrumb>
</div>
